import { z } from 'zod';

const envConfigSchema = z.object({
  VITE_ENABLE_MOCKS: z.stringbool().optional(),
  VITE_API_DEBUG_DELAY: z.coerce.number().optional(),
  VITE_API_BASE_URL: z.string().optional(),
  VITE_BUILD_NUMBER: z.string().optional(),
  VITE_NOMINATIM_BASE_URL: z.string().optional(),
  VITE_ELEVATION_BASE_URL: z.string().optional(),
  VITE_MAP_TILE_URL: z.string().optional(),
  VITE_GEO_RATE_LIMIT_MS: z.coerce.number().optional(),
  VITE_GEO_DEBOUNCE_MS: z.coerce.number().optional(),
});

const parsedEnv = envConfigSchema.safeParse(import.meta.env);

if (!parsedEnv.success) {
  const errorMessages = parsedEnv.error.issues
    .map((issue) => `  • ${issue.path}: ${issue.message}`)
    .join('\n');

  throw new Error(
    `❌ Environment Configuration Error\n\nMissing or invalid variables:\n${errorMessages}\n\nCheck your .env file.`
  );
}

export const ENV_CONFIG = {
  enableMocks: parsedEnv.data.VITE_ENABLE_MOCKS,
  apiDebugDelay: parsedEnv.data.VITE_API_DEBUG_DELAY ?? 0,
  apiBaseUrl: parsedEnv.data.VITE_API_BASE_URL ?? '',
  buildNumber: parsedEnv.data.VITE_BUILD_NUMBER,
  /** Geocoding provider. Point at a self-hosted instance in production. */
  nominatimBaseUrl: parsedEnv.data.VITE_NOMINATIM_BASE_URL ?? 'https://nominatim.openstreetmap.org',
  /** Elevation provider. Point at a self-hosted Open-Elevation instance in production. */
  elevationBaseUrl: parsedEnv.data.VITE_ELEVATION_BASE_URL ?? 'https://api.open-elevation.com',
  /** Map raster tile template. OSM tiles are usable but may be withdrawn at any point. */
  mapTileUrl:
    parsedEnv.data.VITE_MAP_TILE_URL ?? 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
  /** Minimum spacing between two geocoding/elevation requests. Set 0 for self-hosted or tests. */
  geoRateLimitMs: parsedEnv.data.VITE_GEO_RATE_LIMIT_MS ?? 1100,
  /** Debounce applied to address blur and coordinate changes. Set 0 for tests. */
  geoDebounceMs: parsedEnv.data.VITE_GEO_DEBOUNCE_MS ?? 500,
};
